import _ from 'lodash'
// Support for older browsers
// import 'promise-polyfill/src/polyfill'
// import 'whatwg-fetch'

export default class {
  constructor(baseUrl) {
    this._baseUrl = baseUrl
  }

  headers(keys) {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'dataType': 'json',
      ...keys
    }
  }

  get(route, headers) {
    return this._xhr(route, null, headers, 'GET')
  }

  put(route, params, headers = null) {
    return this._xhr(route, params, headers, 'PUT')
  }

  post(route, params, headers = null) {
    return this._xhr(route, params, headers, 'POST')
  }

  delete(route, params, headers = null) {
    return this._xhr(route, params, headers, 'DELETE')
  }

  // use this when you want to completely control the fetch options
  async xhr(url, params, headers, verb) {
    let options = {
      method: verb,
      body: JSON.stringify(params),
      headers: headers
    }

    let resp = await fetch(url, options)
    let json = await resp.json()
    if (resp.ok) {
      return json
    }
    throw json
  }

  // internally used as it will add default headers and use routing
  async _xhr(route, params, headers, verb) {
    let options = Object.assign({ method: verb }, params ? { body: JSON.stringify(params) } : null )

    const url = `${this._baseUrl}${route}`

    options.headers = this.headers(_.omitBy({
      ...headers
    }, _.isEmpty))

    let resp = await fetch(url, options)
    let json = await resp.json()
    if (resp.ok) {
      return json
    }
    throw json
  }

}



// WEBPACK FOOTER //
// ./src/lib/fetcher.js